import Form from './src/form.vue'
import FormItem from './src/form-item-vue'
import { withInstall } from '@el-plus/utils/with-install'
export const EpForm = withInstall(Form)
export default EpForm
export * from './src/form'
export * from './src/form-item'
export { FormItem as EpFormItem }
export type FormInstance = InstanceType<typeof Form>
export type FormItemInstance = InstanceType<typeof FormItem>
